import { render, staticRenderFns } from "./NotificationAlert.vue?vue&type=template&id=57e08896&scoped=true"
import script from "./NotificationAlert.vue?vue&type=script&lang=js"
export * from "./NotificationAlert.vue?vue&type=script&lang=js"
import style0 from "./NotificationAlert.vue?vue&type=style&index=0&id=57e08896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e08896",
  null
  
)

export default component.exports